import React from 'react';
import { Outlet } from 'react-router-dom';

import SuspenseLoading from 'common/components/loading/SuspendLoading';

const PublicLayout = () => {
  return (
    <SuspenseLoading>
      <Outlet />
    </SuspenseLoading>
  );
};

export default PublicLayout;
